module.exports = __webpack_public_path__ + "img/3.92ff8542.jpg";